module.exports = __webpack_public_path__ + "img/255-brazil.f6cfb2a3.svg";